import { createRef, Component } from 'react';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import { parseLocation } from 'automation-ui-routing/utils';
import { atomicQueryUpdate } from 'automation-ui-routing/historyUtils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Because this HOC will wrap the WrappedComponent in a
 * div, make sure this wrappable component is NOT a
 * Fragment, as that could cause weird behavior.
 */
export default function ScrollToElement(WrappedComponent, smoothScrolling = false) {
  const componentName = getComponentName(WrappedComponent);
  class ScrollToElementDecorator extends Component {
    constructor(props) {
      super(props);
      this.containerRef = /*#__PURE__*/createRef();
      this.passThroughRef = /*#__PURE__*/createRef();
    }
    componentDidMount() {
      this.scrollToElementOnceIfNeeded();
      const queryObj = parseLocation(this.props.location) || {};
      const id = queryObj.scrollToElementId;
      this.scrollToElement(id, true);
    }
    componentDidUpdate() {
      this.scrollToElementOnceIfNeeded();
      const locationState = this.props.location.state || {};
      this.scrollToElement(locationState.scrollToElementId);
    }
    scrollToElementOnceIfNeeded() {
      const queryObj = parseLocation(this.props.location) || {};
      const id = queryObj.scrollToElementOnceId;
      const element = this.scrollToElement(id, true);
      if (element) {
        atomicQueryUpdate({}, ['scrollToElementOnceId'], this.props.history);
      }
    }
    scrollToElement(scrollToElementId, overrideSmoothScrolling = false) {
      if (!scrollToElementId || !this.containerRef.current) {
        return null;
      }
      const rootContainer = this.passThroughRef.current ? this.passThroughRef.current : this.containerRef.current;
      const element = rootContainer.querySelector(`[data-scroll-to-id="${scrollToElementId}"]`);
      if (element) {
        element.scrollIntoView({
          behavior: smoothScrolling && !overrideSmoothScrolling ? 'smooth' : 'auto',
          block: 'center',
          inline: 'center'
        });
        return element;
      }
      return null;
    }
    render() {
      return /*#__PURE__*/_jsx("div", {
        ref: this.containerRef,
        children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
          scrollElementRef: this.passThroughRef
        }))
      });
    }
  }
  ScrollToElementDecorator.displayName = `ScrollToElement(${componentName})`;
  ScrollToElementDecorator.defaultProps = WrappedComponent.defaultProps;
  attachWrappedComponent(ScrollToElementDecorator, WrappedComponent);
  return withRouter(ScrollToElementDecorator);
}